var _mask, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlayIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 34,
    viewBox: "0 0 30 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_528_158",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0L30 17L1.9791e-06 34L0 0Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0L30 17L1.9791e-06 34L0 0Z",
    fill: "#DFF8FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0L1.47904 -2.61007L-3 -5.14819L-3 1.74626e-07L0 0ZM30 17L31.479 19.6101L36.085 17L31.479 14.3899L30 17ZM1.9791e-06 34H-3L-3 39.1482L1.47904 36.6101L1.9791e-06 34ZM-1.47904 2.61007L28.521 19.6101L31.479 14.3899L1.47904 -2.61007L-1.47904 2.61007ZM28.521 14.3899L-1.47904 31.39L1.47904 36.6101L31.479 19.6101L28.521 14.3899ZM3 34L3 -1.74626e-07L-3 1.74626e-07L-3 34H3Z",
    fill: "#DFF8FF",
    mask: "url(#path-1-inside-1_528_158)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayIcon);
export default __webpack_public_path__ + "static/media/play-icon.e109b086c44b31744617cadfa7ea4f08.svg";
export { ForwardRef as ReactComponent };